import React from "react";
import { Label, Text } from "theme-ui";

const CustomLabel = ({ label, required, colour, ...props }) => {
  if(!label) return <></>;
  const labelArray = label.toString().split("\\n");
  return labelArray.map((str, index) => 
  <Label {...props} sx={{color: colour, mr: "10px", fontSize: "14px", display: "block"}}>
    {str}
    {required && index === (labelArray.length - 1 ) ? <Text sx={{ color: "red", mr: "5px" }}>*</Text> : null}
  </Label>);
};

export default CustomLabel;
